<template>
  <transition name="slide">
    <div class="hs-container-child" v-if="show">
      <c-header :title="title" leftIcon1="return.png" :leftFn1="close"></c-header>
      <div class="details">
        <iframe width="100%" height="100%" :src="url" :key="url"></iframe>
      </div>
    </div>
  </transition>
</template>
<script type="text/ecmascript-6">
export default {
  name: 'c-frame',
  props: {
    title: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: false
    }
  },
  watch: {
    show(val) {
      if (val) {
        if (!this.url) {
          this.close()
        }
      }
    }
  },
  methods: {
    open() {
      this.show = true
    },
    close() {
      this.show = false
    }
  },
  components: {
    CHeader: () => import('components/c-header/c-header')
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.hs-container-child
  position absolute
  width 100%
  height 100%
  left 0
  top 0
  bottom 0
  background-color $color_white
  z-index 200
  >.details
    width 100%
    height calc(100% - 45px)
    background-color $color_gray_background_0
</style>
